// extracted by mini-css-extract-plugin
export default {"imageWrapper":"zF-z","twoColumnImage":"AF-z"};